import React from 'react';
import { CheckSquare, Edit2, Trash2 } from 'lucide-react';
import clsx from 'clsx';
import { ProjectScoping } from '../../types';
import { SectionHeader } from './SectionHeader';

interface TasksSectionProps {
    tasks: ProjectScoping['tasks'];
    isDark: boolean;
    canEdit: boolean;
    onAddTask: () => void;
    onEditTask: (idx: number) => void;
    onDeleteTask: (idx: number) => void;
    onToggleTaskStatus: (idx: number) => void;
    getStatusColor: (status: string) => string;
    getStatusIcon: (status: string) => React.ReactNode;
}

export const TasksSection: React.FC<TasksSectionProps> = ({ tasks, isDark, canEdit, onAddTask, onEditTask, onDeleteTask, onToggleTaskStatus, getStatusColor, getStatusIcon }) => (
    <div className={clsx('p-4 rounded-lg border', isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200')}>
        <SectionHeader icon={CheckSquare} colorClass="text-green-500" title="5. Tasks (Work Breakdown)" onEdit={canEdit ? onAddTask : undefined} canEdit={canEdit} isDark={isDark} />
        <div className="space-y-2">
            {tasks.map((task, idx) => (
                <div key={task.id} className={clsx('flex items-center justify-between p-3 rounded border', isDark ? 'border-slate-700' : 'border-slate-200')}>
                    <div className="flex items-center gap-3 flex-1">
                        <button onClick={() => canEdit && onToggleTaskStatus(idx)} disabled={!canEdit} className={clsx('px-2 py-0.5 rounded text-xs flex items-center gap-1 min-w-[100px] cursor-pointer', getStatusColor(task.status), !canEdit && 'cursor-not-allowed')} title="Click to change status">
                            {getStatusIcon(task.status)}
                            {task.status}
                        </button>
                        <span className={clsx('text-sm flex-1', isDark ? 'text-white' : 'text-slate-800')}>{task.name}</span>
                        <span className="text-xs text-slate-500">{task.owner}</span>
                        <span className="text-xs font-mono text-slate-500">{task.dueDate.toLocaleDateString()}</span>
                    </div>
                    {canEdit && (
                        <div className="flex gap-1">
                            <button onClick={() => onEditTask(idx)} className="p-1 hover:bg-slate-700 rounded"><Edit2 size={14} className="text-slate-400" /></button>
                            <button onClick={() => onDeleteTask(idx)} className="p-1 hover:bg-red-700 rounded"><Trash2 size={14} className="text-red-400" /></button>
                        </div>
                    )}
                </div>
            ))}
        </div>
    </div>
);
